<script>
import List from "@/components/molecules/list";
import AccordionItem from "@/components/molecules/accordion/accordion-item";
import LazyImage from "@/components/atoms/lazy-image";
import PopinAnchor from "@/components/molecules/popin-anchor";

import pictoAlcoolWeb from "@/assets/images/picto-alcool-web.svg";

export default {
  name: "ProductCategory",
  components: { List, AccordionItem, LazyImage, PopinAnchor },
  props: {
    alcool: {
      type: Boolean,
      required: false,
      default: false
    },
    grid: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props, context) {
    const accordionItem = ref();
    const setOpened = (value) => {
      accordionItem.value.setOpened(value);
    };
    context.expose({ setOpened });

    return { accordionItem, setOpened, pictoAlcoolWeb };
  }
};
</script>

<template>
  <AccordionItem
    ref="accordionItem"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    class="c-product-category"
  >
    <template #title>
      <div :class="alcool && 'c-product-category-alcool'">
        <slot name="title" />
        <div
          v-if="alcool"
          class="u-flex u-flex-shrink-none u-pl-xs c-product-category-alcool__tooltips"
        >
          <PopinAnchor
            tag="div"
            popin-size="xs"
            position="bottom"
            open-on-hover
            infobulle
            radius="md"
            aria-label="La loi interdit la vente d’alcool aux mineurs"
          >
            <template #button-content>
              <LazyImage
                :src="pictoAlcoolWeb"
                width="102"
                height="45"
              />
            </template>
            <p class="u-font-primary u-font-14 u-font-400 u-color-text">
              La loi interdit la vente d’alcool aux mineurs
            </p>
          </PopinAnchor>
        </div>
      </div>
    </template>
    <template #subtitle>
      <slot name="subtitle" />
    </template>

    <div
      class="c-product-category__list-container"
      :class="{'c-product-category__list-container--grid': grid}"
    >
      <List
        class="c-product-category__list"
        :class="{ 'c-product-category__list--grid': grid }"
      >
        <slot />
      </List>
    </div>
  </AccordionItem>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/product-category.scss";
</style>
